import { render, staticRenderFns } from "./PageDefault.vue?vue&type=template&id=34dda460&scoped=true"
import script from "./PageDefault.vue?vue&type=script&lang=js"
export * from "./PageDefault.vue?vue&type=script&lang=js"
import style0 from "./PageDefault.vue?vue&type=style&index=0&id=34dda460&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34dda460",
  null
  
)

export default component.exports